export default "__VITE_ASSET__DjyllHpi__"